import { Text } from '@/components/@base/typography';

export default function ProductInfo({
  title,
  subTitle,
}: {
  title: string | number;
  subTitle: string;
}) {
  return (
    <>
      <Text className='text-[33px] font-bold leading-6 text-[#1F2025] lg:text-[40px]'>
        {title}
      </Text>
      <Text className='font-light text-[13px] leading-8 tracking-tighter text-[#76767C] lg:text-[15px]'>
        {subTitle}
      </Text>
    </>
  );
}
